import { TStatusBadgeType } from '@/common/types/badge';

export const UPDATE_STATUS_TYPE: Record<number, TStatusBadgeType> = {
  1: 'green', // Активен
  2: 'yellow', // Истекает
  3: 'red', // Истек
  4: 'grey', // Неприменимо
};

export const AUTO_UPDATE_TOOLTIP = 'Значение показателя обновляется автоматически';
